import Constantes from 'configs/constantes';
import Language from 'helpers/Language';

const lang = Language.getUrlLanguage();
let home = 'https://localhost:8000';

if (!Constantes.isDev()) {
	home = '';
}
let urlApi = home + '/api';
let media = home + 'media/';
let mediaResized = home + '/media/resized/';

home += '/' + lang;

let baseGroupImage = home + '/images/domino/group/';
let basePreviewText = home + '/preview/text/:font/:text/:colorText/:colorBg/:marginWidth/:marginHeight/';
let baseExport = home + '/export/:sessionId';
let baseLogin = home + '/auth/:sessionId';


const Urls = {
	api: urlApi,
	home,
	baseGroupImage,
	basePreviewText,
	baseExport,
	baseLogin,
	media,
	mediaResized
};

export default Urls;
